// @flow
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { RouteUtil } from 'utils/RouteUtil';
import Slider from 'react-slick';
import { PaginationControl } from 'components/molecules/paginationControl';
import { ProjectAnnouncementCard } from 'components/molecules/projectAnnouncementCard';
import type { ProjectAnnouncement } from 'types/project';
import { useViewport } from 'components/templates/viewportProvider';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  announcements: Array<ProjectAnnouncement>,
};

const ProjectAnnouncementsCarousel = (props: Props) => {
  const { height } = useViewport();
  const [viewport, setViewport] = useState({
    width: 0,
    height: 0,
  });

  const updateWindowDimensions = () => {
    setViewport({
      ...viewport,
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  const [activeSlide, setActiveSlide] = useState(0);
  const [slider, setSlider] = useState();

  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);
    return () => {
      window.removeEventListener('resize', updateWindowDimensions);
    };
  }, []);

  const { announcements, onGetInTouchClick, checkForCTAButton } = props;
  if (!announcements) {
    return null;
  }

  const settings = {
    className: 'slider announcements-carousel',
    infinite: true,
    centerMode: true,
    variableWidth: true,
    speed: 1000,
    beforeChange: (current, next) => setActiveSlide(next),
    arrows: false,
    draggable: true,
    cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
  };

  const onProjectAnnouncementClick = urlSlug => {
    const redirectionURl = urlSlug;
    if (redirectionURl) {
      const matches =
        redirectionURl.includes('https') ||
        redirectionURl.includes('http') ||
        redirectionURl.toUpperCase().includes('https') ||
        redirectionURl.toLowerCase().includes('https');
      if (!matches) {
        RouteUtil.setRouteChange(props, redirectionURl);
      } else {
        window.location.assign(`${redirectionURl}`);
      }
    }
  };

  const checkAnnouncementURL = urlSlug => {
    if (checkForCTAButton === true && !urlSlug) onGetInTouchClick(true);
    else onProjectAnnouncementClick(urlSlug);
  };

  const renderContent = () => {
    return (
      <Slider ref={c => setSlider(c)} {...settings} style={{ height: '100%' }}>
        {announcements.map(announcement => {
          return (
            <ProjectAnnouncementCard
              data={announcement}
              onClick={() => checkAnnouncementURL(announcement.urlSlug)}
              className={'project-announcements-card'}
              key={announcement.id}
              ctaText={
                checkForCTAButton === true && !announcement.urlSlug
                  ? 'GET IN TOUCH'
                  : 'LEARN MORE'
              }
            />
          );
        })}
      </Slider>
    );
  };

  // Render footer
  const next = () => {
    slider.slickNext();
  };

  const previous = () => {
    slider.slickPrev();
  };

  const renderFooter = () => {
    return (
      <div className={'section-footer show-explore'}>
        <PaginationControl
          className={'section-footer-item'}
          theme={'dark-theme'}
          currentIndex={activeSlide + 1}
          total={announcements.length}
          onNextClick={next}
          onPreviousClick={previous}
        />
      </div>
    );
  };

  return (
    <div
      className={'section-container no-gutter'}
      style={{ height }}
      id={'announcements'}
    >
      {renderContent()}
      {renderFooter()}
    </div>
  );
};

export default withRouter(ProjectAnnouncementsCarousel);
